// src/components/Steps/TeamBuilderStep.js
import TeamMemberBuilder from '../TeamMemberBuilder/Index';

export default function TeamMemberBuilderStep({
  competition,
  competitionDate,
  team,
  setStep,
  setTeam,
  setEditingTeam
}) {
  const afterActivate = () => {
    setTeam(null)
    setStep(4)
    setEditingTeam(false)
  }

  return (
    <TeamMemberBuilder
      competition={competition}
      team={team}
      competition_event_id={competitionDate.id}
      afterActivate={afterActivate}
    />
  );
}